// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Smart Board Container - Premium Dark Theme */
.smart-board-container {
  width: 100%;
  padding: 0 8px;
  position: relative;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Fixed Header Section — compact inline bar */
.fixed-header {
  flex-shrink: 0;
  margin: 0 4px 4px 0;
  padding: 0;
}

/* Scrollable Sectors Container */
.sectors-scroll-container {
  flex: 1 1;
  overflow-y: auto;
  padding-bottom: 24px;
    padding-top: 4px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;
}

.sectors-scroll-container::-webkit-scrollbar {
  width: 5px;
}

.sectors-scroll-container::-webkit-scrollbar-track {
  background: transparent;
}

.sectors-scroll-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

.sectors-scroll-container::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}

/* Header */
.smart-board-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* View Mode Dropdown */
.view-mode-dropdown {
  position: relative;
  flex-shrink: 0;
}

.view-mode-btn {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px 8px 14px;
  min-width: 110px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(79, 70, 229, 0.1) 100%);
  color: #a5b4fc;
  border: 1px solid rgba(99, 102, 241, 0.25);
  border-radius: 5px;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
  letter-spacing: 0.2px;
}

.view-mode-btn:hover {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.25) 0%, rgba(79, 70, 229, 0.18) 100%);
  border-color: rgba(99, 102, 241, 0.4);
  color: #c7d2fe;
}

/* Min Range Date Picker */
.min-range-picker {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.min-range-picker .min-date-input {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 5px;
  color: #e2e8f0;
  font-size: 11px;
  font-weight: 600;
  padding: 6px 10px;
  font-family: 'Inter', sans-serif;
  cursor: pointer;
  outline: none;
  width: 190px;
  transition: border-color 0.15s;
}

.min-range-picker .min-date-input:hover {
  border-color: rgba(255, 255, 255, 0.25);
}

.min-range-picker .min-date-input:focus {
  border-color: rgba(99, 102, 241, 0.5);
}

.min-loading-indicator {
  color: #64748b;
  font-size: 12px;
  animation: pulse 1s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

/* React DatePicker Dark Theme Overrides */
.react-datepicker {
  background: #1a1b23 !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
  border-radius: 10px !important;
  font-family: 'Inter', sans-serif !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6) !important;
  font-size: 12px !important;
}

.react-datepicker__header {
  background: #22232b !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 10px 10px 0 0 !important;
  padding: 8px 0 4px !important;
}

.react-datepicker__current-month,
.react-datepicker__day-name {
  color: #e2e8f0 !important;
}

.react-datepicker__day-name {
  color: #64748b !important;
  font-size: 11px !important;
  width: 32px !important;
  line-height: 28px !important;
}

.react-datepicker__day {
  color: #cbd5e1 !important;
  width: 32px !important;
  line-height: 28px !important;
  border-radius: 6px !important;
  transition: background 0.1s !important;
}

.react-datepicker__day:hover {
  background: rgba(99, 102, 241, 0.2) !important;
  color: #e2e8f0 !important;
}

.react-datepicker__day--selected,
.react-datepicker__day--range-start,
.react-datepicker__day--range-end,
.react-datepicker__day--selecting-range-start,
.react-datepicker__day--selecting-range-end {
  background: #4ade80 !important;
  color: #0f172a !important;
  font-weight: 700 !important;
  border-radius: 6px !important;
}

.react-datepicker__day--in-range {
  background: rgba(74, 222, 128, 0.15) !important;
  color: #e2e8f0 !important;
}

.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
  background: rgba(74, 222, 128, 0.1) !important;
  color: #e2e8f0 !important;
}

.react-datepicker__day--keyboard-selected {
  background: rgba(74, 222, 128, 0.2) !important;
  color: #e2e8f0 !important;
}

.react-datepicker__day--disabled {
  color: #334155 !important;
  cursor: not-allowed !important;
}

.react-datepicker__day--disabled:hover {
  background: transparent !important;
}

.react-datepicker__day--outside-month {
  color: #334155 !important;
}

.react-datepicker__navigation {
  top: 10px !important;
}

.react-datepicker__navigation-icon::before {
  border-color: #94a3b8 !important;
}

.react-datepicker__navigation:hover .react-datepicker__navigation-icon::before {
  border-color: #e2e8f0 !important;
}

.react-datepicker__triangle {
  display: none !important;
}

.react-datepicker-popper {
  left: 0 !important;
  z-index: 9999 !important;
}

.react-datepicker__month-dropdown-container,
.react-datepicker__year-dropdown-container {
  margin: 0 4px !important;
}

.react-datepicker__month-dropdown-container select,
.react-datepicker__year-dropdown-container select,
.react-datepicker__month-select,
.react-datepicker__year-select {
  background: #2a2b35 !important;
  color: #e2e8f0 !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 4px !important;
  padding: 2px 4px !important;
  font-size: 12px !important;
  cursor: pointer !important;
}

.react-datepicker__close-icon {
  padding-right: 4px !important;
}

.react-datepicker__close-icon::after {
  background: rgba(248, 113, 113, 0.15) !important;
  color: #f87171 !important;
  font-size: 14px !important;
  height: 18px !important;
  width: 18px !important;
  line-height: 16px !important;
}

.view-mode-chevron {
  transition: transform 0.2s ease;
}

.view-mode-chevron.open {
  transform: rotate(180deg);
}

.view-mode-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 150px;
  background: #1a1b23;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 4px;
  z-index: 9999;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
  animation: dropdownFadeIn 0.12s ease-out;
}

@keyframes dropdownFadeIn {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: translateY(0); }
}

.view-mode-option {
  padding: 8px 12px;
  font-size: 12px;
  color: #94a3b8;
  cursor: pointer;
  border-radius: 5px;
  transition: background 0.1s ease;
  -webkit-user-select: none;
          user-select: none;
}

.view-mode-option:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #e2e8f0;
}

.view-mode-option.active {
  color: #a5b4fc;
  background: rgba(99, 102, 241, 0.15);
}

/* Stats on the right */
.header-stats {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
  min-width: 120px;
  margin-left: auto;
}

.header-stats .stat-up {
  color: #4ade80;
}

.header-stats .stat-flat {
  color: #fbbf24;
}

.header-stats .stat-down {
  color: #f87171;
}

/* Floating Add Sector Button (FAB) — bottom right */
.fab-add-sector {
  position: absolute;
  bottom: 24px;
  right: 24px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(74, 222, 128, 0.3) 0%, rgba(34, 197, 94, 0.25) 100%);
  color: #4ade80;
  border: 1px solid rgba(74, 222, 128, 0.4);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.fab-add-sector:hover {
  background: linear-gradient(135deg, rgba(74, 222, 128, 0.45) 0%, rgba(34, 197, 94, 0.35) 100%);
  border-color: rgba(74, 222, 128, 0.6);
  color: #86efac;
  box-shadow: 0 6px 20px rgba(74, 222, 128, 0.25);
  transform: scale(1.08);
}

.fab-add-sector:active {
  transform: scale(0.95);
}

.fab-tooltip {
  position: absolute;
  right: 56px;
  white-space: nowrap;
  background: rgba(30, 30, 30, 0.95);
  color: #e2e8f0;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: 6px;
  pointer-events: none;
  opacity: 0;
  transform: translateX(4px);
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.fab-add-sector:hover .fab-tooltip {
  opacity: 1;
  transform: translateX(0);
}

.header-title {
  color: #e2e8f0;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.3px;
  flex-shrink: 0;
  display: none;
}

.smart-board-header p {
  margin: 0;
  color: #64748b;
  font-size: 13px;
  flex-shrink: 0;
  display: none;
}

.connection-status {
  font-size: 11px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 20px;
  display: none;
}

.connection-status.connected {
  color: #4ade80;
  background: rgba(74, 222, 128, 0.1);
}

.connection-status.disconnected {
  color: #f87171;
  background: rgba(248, 113, 113, 0.1);
}

/* ===== MARKET INDICES — inline compact ===== */
.market-indices {
  display: flex;
  gap: 6px;
  flex: 1 1;
  justify-content: center;
  align-items: stretch;
}

.index-card {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 14px;
  background: #22232b;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  transition: all 0.2s ease;
  overflow: hidden;
  flex-shrink: 0;
  min-width: 180px;
}

.index-card:hover {
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

/* Index Card Color Variants */
.index-card.positive {
  border-color: rgba(74, 222, 128, 0.15);
}

.index-card.negative {
  border-color: rgba(248, 113, 113, 0.15);
}

.index-card.neutral {
  border-color: rgba(255, 255, 255, 0.06);
}

/* Row Top — Price + Change */
.index-row-top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

/* Row Bottom — Symbol + Volume */
.index-row-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.index-symbol {
  font-size: 11px;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: 0.2px;
  text-transform: uppercase;
}

.index-volume {
  font-family: 'JetBrains Mono', 'Fira Code', 'SF Mono', 'Consolas', monospace;
  font-size: 11px;
  font-weight: 600;
  color: #ffffff;
  letter-spacing: 0;
}

.index-change {
  font-size: 12px;
  font-weight: 700;
  padding: 0;
  border-radius: 0;
  background: none;
}

/* Change text colors — green positive, red negative */
.index-card.positive .index-change {
  color: #4ade80;
}

.index-card.negative .index-change {
  color: #f87171;
}

.index-card.neutral .index-change {
  color: #94a3b8;
}

/* Price */
.index-price {
  font-family: 'JetBrains Mono', 'Fira Code', 'SF Mono', 'Consolas', monospace;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.3px;
  line-height: 1;
}

/* Index price colors — always white */
.index-card.positive .index-price,
.index-card.negative .index-price,
.index-card.neutral .index-price {
  color: #ffffff;
}

/* Sparkline Chart (hidden) */
.index-sparkline {
  display: none;
}

/* Responsive — tablet */
@media (max-width: 768px) {
  .smart-board-header {
    flex-wrap: wrap;
    gap: 4px;
    margin-bottom: 4px;
  }

  .header-stats {
    min-width: auto;
    gap: 6px;
    font-size: 10px;
  }

  .market-indices {
    flex: 1 1;
    gap: 4px;
    overflow-x: auto;
    justify-content: flex-start;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }

  .market-indices::-webkit-scrollbar {
    display: none;
  }

  .index-card {
    padding: 4px 10px;
    gap: 1px;
    min-width: 150px;
  }

  .index-symbol {
    font-size: 9px;
  }

  .index-volume {
    font-size: 9px;
  }

  .index-change {
    font-size: 10px;
  }

  .index-price {
    font-size: 14px;
  }
}

/* Responsive — mobile */
@media (max-width: 480px) {
  .smart-board-container {
    padding: 0 4px;
  }

  .fixed-header {
    margin: 0 0 2px 0;
  }

  .smart-board-header {
    gap: 3px;
  }

  .header-stats {
    gap: 5px;
    font-size: 10px;
  }

  .index-card {
    padding: 3px 8px;
    gap: 0;
    min-width: 130px;
  }

  .index-symbol {
    font-size: 8px;
  }

  .index-volume {
    font-size: 8px;
  }

  .index-change {
    font-size: 9px;
  }

  .index-price {
    font-size: 13px;
  }

  .index-row-top {
    gap: 6px;
  }

  .table-header,
  .table-row {
    gap: 3px;
    padding: 2px 3px;
  }

  .sector-card {
    border-radius: 4px;
  }
}

/* ===== SECTORS GRID ===== */
.sectors-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 6px;
  align-items: start;
}

@media (min-width: 1200px) {
  .sectors-grid {
    grid-template-columns: repeat(8, 1fr);
  }
}

@media (min-width: 900px) and (max-width: 1199px) {
  .sectors-grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (max-width: 899px) {
  .sectors-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 4px;
  }
}

@media (max-width: 560px) {
  .sectors-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;
  }

  .table-header,
  .table-row {
    gap: 3px;
    padding: 2px 4px;
  }
}

/* ===== SECTOR CARD ===== */
.sector-card {
  background: #22232b;
  border-radius: 6px;
  overflow: hidden;
  min-width: 0;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.sector-card:hover:not(.dragging) {
  border-color: rgba(255, 255, 255, 0.12);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* ===== SECTOR HEADER ===== */
.sector-header {
  background: #2a2b35;
  padding: 5px 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.sector-header h3 {
  margin: 0;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

/* ===== SECTOR TABLE ===== */
.sector-table {
  font-size: 10px;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}

.table-header {
  display: flex;
  align-items: center;
  padding: 3px 5px;
  background: #282930;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  font-weight: 700;
  color: #64748b;
  font-size: 8px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  flex-shrink: 0;
}

.table-header .col-symbol {
  text-align: left;
  color: #ffffff;
}

.table-header .col-price,
.table-header .col-change,
.table-header .col-volume,
.table-header .col-min22-price,
.table-header .col-min22,
.table-header .col-min22-pct {
  text-align: right;
  color: #ffffff;
}

/* Table body */
.table-body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.table-row {
  display: flex;
  align-items: center;
  padding: 4px 6px;
  transition: background 0.15s ease;
  background: #1e1f27;
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 3px;
}

/* Zebra striping */
.table-row:nth-child(even) {
  background: #22232b;
}

.table-row:last-child {
  /* gap handles spacing now */
}

.table-row:hover {
  filter: brightness(1.15);
}

/* ===== ROW BACKGROUND COLORS ===== */
.table-row.ceiling {
  background: rgba(255,128,255);
}

.table-row.positive {
  background: #00EE00;
}

.table-row.positive-muted {
  background: #98fb98;
}

.table-row.negative {
  background: rgba(255,62,62);
}

.table-row.negative-muted {
  background: rgba(255,193,193);
}

.table-row.neutral {
  background: rgba(255,255,128);
}

.table-row.floor {
  background: rgba(0,255,255);
}

/* ===== CATCH-ALL: Dark text on ALL colored row backgrounds ===== */
.table-row.ceiling span,
.table-row.positive span,
.table-row.positive-muted span,
.table-row.negative span,
.table-row.negative-muted span,
.table-row.neutral span,
.table-row.floor span {
  color: #0f172a !important;
}

/* ===== COLUMNS ===== */
.col-symbol,
.col-price,
.col-change,
.col-volume {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
}

.col-symbol {
  flex: 0 1 20%;
  font-weight: 600;
  color: #e2e8f0;
  font-size: 12px;
  text-align: left;
}

.col-price {
  flex: 0 1 20%;
  text-align: right;
  font-weight: 600;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  color: #e2e8f0;
}

/* ===== PRICE COLORS — Dark text on colored background ===== */
.table-row.ceiling .col-price,
.table-row.positive .col-price,
.table-row.positive-muted .col-price,
.table-row.negative .col-price,
.table-row.negative-muted .col-price,
.table-row.neutral .col-price,
.table-row.floor .col-price {
  color: #0f172a;
}

/* ===== CHANGE % BADGE ===== */
.col-change {
  flex: 0 1 40%;
  text-align: right;
  font-weight: 600;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  padding: 1px 4px;
  border-radius: 3px;
  color: #e2e8f0;
}

/* Change badge colors — Dark text on colored background */
.col-change.ceiling,
.col-change.positive,
.col-change.positive-muted,
.col-change.negative,
.col-change.negative-muted,
.col-change.neutral,
.col-change.floor {
  color: #0f172a;
}

/* Volume */
.col-volume {
  flex: 0 1 20%;
  text-align: right;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  padding: 0;
}

/* Volume colors — Dark text on colored background */
.col-volume.ceiling,
.col-volume.positive,
.col-volume.positive-muted,
.col-volume.negative,
.col-volume.negative-muted,
.col-volume.neutral,
.col-volume.floor {
  color: #0f172a;
}

/* Symbol color — Dark text on colored background */
.table-row.ceiling .col-symbol,
.table-row.positive .col-symbol,
.table-row.positive-muted .col-symbol,
.table-row.negative .col-symbol,
.table-row.negative-muted .col-symbol,
.table-row.neutral .col-symbol,
.table-row.floor .col-symbol {
  color: #0f172a;
}

/* ===== MIN 22 COLUMNS ===== */
.col-min22-price {
  flex: 1 1;
  color: #e2e8f0;
}

.table-row.positive .col-min22-price,
.table-row.negative .col-min22-price,
.table-row.neutral .col-min22-price,
.table-row.positive-muted .col-min22-price,
.table-row.negative-muted .col-min22-price,
.table-row.ceiling .col-min22-price,
.table-row.floor .col-min22-price {
  color: #0f172a;
}

.col-min22-price,
.col-min22,
.col-min22-pct {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
  font-size: 12px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  text-align: right;
}

.col-min22 {
  flex: 1 1;
  color: #e2e8f0;
}

.col-min22-pct {
  flex: 1 1;
  padding: 1px 4px;
  border-radius: 3px;
}

/* Min22 text colors on colored backgrounds */
.table-row.positive .col-min22,
.table-row.negative .col-min22,
.table-row.neutral .col-min22,
.table-row.positive-muted .col-min22,
.table-row.negative-muted .col-min22,
.table-row.ceiling .col-min22,
.table-row.floor .col-min22 {
  color: #0f172a;
}

.col-min22-pct.positive,
.col-min22-pct.negative,
.col-min22-pct.neutral,
.col-min22-pct.positive-muted,
.col-min22-pct.negative-muted,
.col-min22-pct.ceiling,
.col-min22-pct.floor {
  color: #0f172a;
}

.table-header .col-min22-price,
.table-header .col-min22,
.table-header .col-min22-pct {
  color: #e2e8f0;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
}

/* ===== LOADING OVERLAY ===== */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(26, 27, 35, 0.85);
  z-index: 9999;
  backdrop-filter: blur(4px);
}

body.loading-active {
  overflow: hidden;
}

/* ===== TOAST NOTIFICATION ===== */
.toast-container {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.toast {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  animation: toast-slide-in 0.3s ease;
  max-width: 320px;
}

.toast.error {
  background: #2a2b35;
  color: #f87171;
  border: 1px solid rgba(248, 113, 113, 0.2);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
}

.toast.success {
  background: #1a2e1a;
  color: #4ade80;
  border: 1px solid rgba(74, 222, 128, 0.25);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
}

.toast .toast-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.toast.success .toast-icon {
  color: #4ade80;
}

.toast.error .toast-icon {
  color: #f87171;
}

.toast .toast-message {
  flex: 1 1;
}

.toast .toast-action {
  padding: 4px 10px;
  background: rgba(251, 113, 133, 0.12);
  color: #fb7185;
  border: 1px solid rgba(251, 113, 133, 0.2);
  border-radius: 4px;
  cursor: pointer;
  font-size: 10px;
  font-weight: 500;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.toast .toast-action:hover {
  background: rgba(251, 113, 133, 0.2);
}

.toast .toast-close {
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  padding: 2px;
  font-size: 14px;
  line-height: 1;
  transition: color 0.2s ease;
}

.toast .toast-close:hover {
  color: #94a3b8;
}

@keyframes toast-slide-in {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* (responsive adjustments moved to main responsive block above) */

/* ===== DRAG AND DROP STYLES ===== */

/* Ghost card — the dragged item shown at its preview drop position */
.sector-card.drag-ghost {
  opacity: 0.25;
  border: 2px dashed rgba(59, 130, 246, 0.6) !important;
  background: rgba(59, 130, 246, 0.06) !important;
  pointer-events: none;
  box-shadow: none !important;
}

.sector-card.drag-ghost * {
  opacity: 0.3;
}

/* Active drag state on the grid */
.sectors-grid.dragging-active {
  background: rgba(40, 115, 255, 0.02);
  border-radius: 8px;
}

/* Make cards accept drops */
.sector-card[draggable="true"] {
  cursor: grab;
}

.sector-card[draggable="true"]:active {
  cursor: grabbing;
}

.drag-handle {
  position: absolute;
  left: 6px;
  color: rgba(255, 255, 255, 0.3);
  font-size: 10px;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  letter-spacing: -2px;
  transition: color 0.2s ease;
}

.drag-handle:hover {
  color: rgba(255, 255, 255, 0.6);
}

/* ===== SECTOR HEADER ADD BUTTON (LEFT) ===== */
.sector-add-btn {
  position: absolute;
  left: 18px;
  background: rgba(74, 222, 128, 0.15);
  color: rgba(74, 222, 128, 0.8);
  border: none;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.sector-add-btn:hover {
  background: rgba(74, 222, 128, 0.35);
  color: #4ade80;
}

/* ===== SECTOR HEADER DELETE BUTTON (RIGHT) ===== */
.sector-delete-btn {
  position: absolute;
  right: 4px;
  background: rgba(248, 113, 113, 0.1);
  color: rgba(248, 113, 113, 0.6);
  border: none;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.sector-delete-btn:hover {
  background: rgba(248, 113, 113, 0.3);
  color: #f87171;
}

/* ===== ROW REMOVE BUTTON ===== */
.row-remove-btn {
  position: absolute;
  right: 2px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  color: #64748b;
  border: none;
  width: 18px;
  height: 18px;
  border-radius: 3px;
  cursor: pointer;
  display: none;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 2px;
}

.table-row:hover .row-remove-btn {
  display: flex;
  color: #BD1342;
}

.row-remove-btn:hover {
  background: #ffffff;
  color: #ffffff;
}

/* ===== MODAL ===== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: #22232b;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  width: 90%;
  max-width: 400px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  animation: modal-appear 0.2s ease;
}

@keyframes modal-appear {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.modal-header h3 {
  margin: 0;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  color: #64748b;
  font-size: 20px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: color 0.2s ease;
}

.modal-close:hover {
  color: #94a3b8;
}

.modal-body {
  padding: 20px;
}

.modal-body input {
  width: 100%;
  padding: 12px 16px;
  background: #1a1b23;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: #e2e8f0;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.2s ease;
}

.modal-body input:focus {
  border-color: rgba(40, 115, 255, 0.5);
}

.modal-body input::placeholder {
  color: #64748b;
}

.modal-body p {
  margin: 0;
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.5;
}

.modal-error {
  color: #fb7185;
  font-size: 13px;
  margin-top: 12px;
}

.modal-warning {
  color: #fbbf24;
  font-size: 12px;
  margin-top: 8px;
  font-style: italic;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.modal-btn {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s ease;
}

.modal-btn.cancel {
  background: rgba(255, 255, 255, 0.06);
  color: #94a3b8;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.modal-btn.cancel:hover {
  background: rgba(255, 255, 255, 0.1);
}

.modal-btn.confirm {
  background: #2873ff;
  color: #ffffff;
  border: 1px solid #2873ff;
}

.modal-btn.confirm:hover:not(:disabled) {
  background: #2060e0;
}

.modal-btn.danger {
  background: #ef4444;
  color: #ffffff;
  border: 1px solid #ef4444;
}

.modal-btn.danger:hover:not(:disabled) {
  background: #dc2626;
}

.modal-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ===== Early Signals Floating Button & Panel ===== */
.signals-fab {
  position: fixed;
  bottom: 100px;
  right: 24px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #3b82f6;
  color: white;
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
  z-index: 100;
  transition: transform 0.2s, background 0.2s, box-shadow 0.2s;
  -webkit-tap-highlight-color: transparent;
}

.signals-fab:hover {
  transform: scale(1.1);
  background: #2563eb;
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.5);
}

.signals-fab.active {
  background: #1d4ed8;
  transform: scale(1);
}

/* Overlay */
.signals-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 199;
}

/* Right sidebar panel */
.signals-panel {
  position: fixed;
  top: 0;
  right: -900px;
  width: 900px;
  height: 100vh;
  background: #141520;
  border-left: 1px solid rgba(255, 255, 255, 0.08);
  z-index: 200;
  display: flex;
  flex-direction: column;
  transition: right 0.3s ease;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.4);
}

.signals-panel.open {
  right: 0;
}

.signals-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

.signals-panel-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #e2e8f0;
}

.signals-panel-close {
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  transition: color 0.15s, background 0.15s;
}

.signals-panel-close:hover {
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.08);
}

.signals-panel-body {
  flex: 1 1;
  overflow: hidden;
}

/* Mobile */
@media (max-width: 768px) {
  .signals-panel {
    width: 100vw;
    right: -100vw;
  }

  .signals-fab {
    bottom: 16px;
    right: 16px;
    width: 44px;
    height: 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SmartBoard.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,uFAAuF;EACvF,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE,SAAO;EACP,gBAAgB;EAChB,oBAAoB;IAClB,gBAAgB;EAClB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,0BAA0B;EAC1B,gBAAgB;EAChB,6FAA6F;EAC7F,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,8FAA8F;EAC9F,qCAAqC;EACrC,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,0CAA0C;AAC1C;EACE,8BAA8B;EAC9B,sDAAsD;EACtD,8BAA8B;EAC9B,2CAA2C;EAC3C,qDAAqD;EACrD,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,6DAA6D;EAC7D,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;;;;;EAKE,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;;EAEE,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;;EAIE,8BAA8B;EAC9B,yBAAyB;EACzB,qDAAqD;EACrD,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6FAA6F;EAC7F,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,8FAA8F;EAC9F,qCAAqC;EACrC,cAAc;EACd,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,QAAQ;EACR,SAAO;EACP,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA,8BAA8B;AAC9B;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,4EAA4E;EAC5E,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,4EAA4E;EAC5E,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;;;EAGE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE;IACE,eAAe;IACf,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,QAAQ;IACR,gBAAgB;IAChB,2BAA2B;IAC3B,iCAAiC;IACjC,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;;IAEE,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,QAAQ;EACV;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,QAAQ;EACV;;EAEA;;IAEE,QAAQ;IACR,gBAAgB;EAClB;AACF;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,wDAAwD;EACxD,aAAa;EACb,sBAAsB;EACtB,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;EAClD,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;EAME,iBAAiB;EACjB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sCAAsC;AACtC;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oEAAoE;AACpE;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;;;;EAIE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;;;;;;;EAOE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;;;;;;;EAOE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,UAAU;AACZ;;AAEA,oDAAoD;AACpD;;;;;;;EAOE,cAAc;AAChB;;AAEA,mDAAmD;AACnD;;;;;;;EAOE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,SAAW;EACX,cAAc;AAChB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;;EAGE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,SAAW;EACX,cAAc;AAChB;;AAEA;EACE,SAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,6CAA6C;AAC7C;;;;;;;EAOE,cAAc;AAChB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mEAAmE;EACnE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,kEAAkE;;AAElE,qCAAqC;;AAErC,qEAAqE;AACrE;EACE,aAAa;EACb,qDAAqD;EACrD,+CAA+C;EAC/C,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,UAAU;EACV,oCAAoC;EACpC,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,UAAU;EACV,oCAAoC;EACpC,+BAA+B;EAC/B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,UAAU;EACV,gBAAgB;EAChB,gDAAgD;EAChD,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,YAAY;EACZ,4DAA4D;EAC5D,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,MAAM;EACN,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gDAAgD;EAChD,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Smart Board Container - Premium Dark Theme */\n.smart-board-container {\n  width: 100%;\n  padding: 0 8px;\n  position: relative;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n/* Fixed Header Section — compact inline bar */\n.fixed-header {\n  flex-shrink: 0;\n  margin: 0 4px 4px 0;\n  padding: 0;\n}\n\n/* Scrollable Sectors Container */\n.sectors-scroll-container {\n  flex: 1;\n  overflow-y: auto;\n  padding-bottom: 24px;\n    padding-top: 4px;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;\n}\n\n.sectors-scroll-container::-webkit-scrollbar {\n  width: 5px;\n}\n\n.sectors-scroll-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sectors-scroll-container::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 3px;\n}\n\n.sectors-scroll-container::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n/* Header */\n.smart-board-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* View Mode Dropdown */\n.view-mode-dropdown {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.view-mode-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px 8px 14px;\n  min-width: 110px;\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.15) 0%, rgba(79, 70, 229, 0.1) 100%);\n  color: #a5b4fc;\n  border: 1px solid rgba(99, 102, 241, 0.25);\n  border-radius: 5px;\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n  user-select: none;\n  letter-spacing: 0.2px;\n}\n\n.view-mode-btn:hover {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.25) 0%, rgba(79, 70, 229, 0.18) 100%);\n  border-color: rgba(99, 102, 241, 0.4);\n  color: #c7d2fe;\n}\n\n/* Min Range Date Picker */\n.min-range-picker {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.min-range-picker .min-date-input {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 5px;\n  color: #e2e8f0;\n  font-size: 11px;\n  font-weight: 600;\n  padding: 6px 10px;\n  font-family: 'Inter', sans-serif;\n  cursor: pointer;\n  outline: none;\n  width: 190px;\n  transition: border-color 0.15s;\n}\n\n.min-range-picker .min-date-input:hover {\n  border-color: rgba(255, 255, 255, 0.25);\n}\n\n.min-range-picker .min-date-input:focus {\n  border-color: rgba(99, 102, 241, 0.5);\n}\n\n.min-loading-indicator {\n  color: #64748b;\n  font-size: 12px;\n  animation: pulse 1s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.3; }\n}\n\n/* React DatePicker Dark Theme Overrides */\n.react-datepicker {\n  background: #1a1b23 !important;\n  border: 1px solid rgba(255, 255, 255, 0.15) !important;\n  border-radius: 10px !important;\n  font-family: 'Inter', sans-serif !important;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6) !important;\n  font-size: 12px !important;\n}\n\n.react-datepicker__header {\n  background: #22232b !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;\n  border-radius: 10px 10px 0 0 !important;\n  padding: 8px 0 4px !important;\n}\n\n.react-datepicker__current-month,\n.react-datepicker__day-name {\n  color: #e2e8f0 !important;\n}\n\n.react-datepicker__day-name {\n  color: #64748b !important;\n  font-size: 11px !important;\n  width: 32px !important;\n  line-height: 28px !important;\n}\n\n.react-datepicker__day {\n  color: #cbd5e1 !important;\n  width: 32px !important;\n  line-height: 28px !important;\n  border-radius: 6px !important;\n  transition: background 0.1s !important;\n}\n\n.react-datepicker__day:hover {\n  background: rgba(99, 102, 241, 0.2) !important;\n  color: #e2e8f0 !important;\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--range-start,\n.react-datepicker__day--range-end,\n.react-datepicker__day--selecting-range-start,\n.react-datepicker__day--selecting-range-end {\n  background: #4ade80 !important;\n  color: #0f172a !important;\n  font-weight: 700 !important;\n  border-radius: 6px !important;\n}\n\n.react-datepicker__day--in-range {\n  background: rgba(74, 222, 128, 0.15) !important;\n  color: #e2e8f0 !important;\n}\n\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {\n  background: rgba(74, 222, 128, 0.1) !important;\n  color: #e2e8f0 !important;\n}\n\n.react-datepicker__day--keyboard-selected {\n  background: rgba(74, 222, 128, 0.2) !important;\n  color: #e2e8f0 !important;\n}\n\n.react-datepicker__day--disabled {\n  color: #334155 !important;\n  cursor: not-allowed !important;\n}\n\n.react-datepicker__day--disabled:hover {\n  background: transparent !important;\n}\n\n.react-datepicker__day--outside-month {\n  color: #334155 !important;\n}\n\n.react-datepicker__navigation {\n  top: 10px !important;\n}\n\n.react-datepicker__navigation-icon::before {\n  border-color: #94a3b8 !important;\n}\n\n.react-datepicker__navigation:hover .react-datepicker__navigation-icon::before {\n  border-color: #e2e8f0 !important;\n}\n\n.react-datepicker__triangle {\n  display: none !important;\n}\n\n.react-datepicker-popper {\n  left: 0 !important;\n  z-index: 9999 !important;\n}\n\n.react-datepicker__month-dropdown-container,\n.react-datepicker__year-dropdown-container {\n  margin: 0 4px !important;\n}\n\n.react-datepicker__month-dropdown-container select,\n.react-datepicker__year-dropdown-container select,\n.react-datepicker__month-select,\n.react-datepicker__year-select {\n  background: #2a2b35 !important;\n  color: #e2e8f0 !important;\n  border: 1px solid rgba(255, 255, 255, 0.1) !important;\n  border-radius: 4px !important;\n  padding: 2px 4px !important;\n  font-size: 12px !important;\n  cursor: pointer !important;\n}\n\n.react-datepicker__close-icon {\n  padding-right: 4px !important;\n}\n\n.react-datepicker__close-icon::after {\n  background: rgba(248, 113, 113, 0.15) !important;\n  color: #f87171 !important;\n  font-size: 14px !important;\n  height: 18px !important;\n  width: 18px !important;\n  line-height: 16px !important;\n}\n\n.view-mode-chevron {\n  transition: transform 0.2s ease;\n}\n\n.view-mode-chevron.open {\n  transform: rotate(180deg);\n}\n\n.view-mode-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  min-width: 150px;\n  background: #1a1b23;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  padding: 4px;\n  z-index: 9999;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);\n  animation: dropdownFadeIn 0.12s ease-out;\n}\n\n@keyframes dropdownFadeIn {\n  from { opacity: 0; transform: translateY(-4px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.view-mode-option {\n  padding: 8px 12px;\n  font-size: 12px;\n  color: #94a3b8;\n  cursor: pointer;\n  border-radius: 5px;\n  transition: background 0.1s ease;\n  user-select: none;\n}\n\n.view-mode-option:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #e2e8f0;\n}\n\n.view-mode-option.active {\n  color: #a5b4fc;\n  background: rgba(99, 102, 241, 0.15);\n}\n\n/* Stats on the right */\n.header-stats {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  flex-shrink: 0;\n  min-width: 120px;\n  margin-left: auto;\n}\n\n.header-stats .stat-up {\n  color: #4ade80;\n}\n\n.header-stats .stat-flat {\n  color: #fbbf24;\n}\n\n.header-stats .stat-down {\n  color: #f87171;\n}\n\n/* Floating Add Sector Button (FAB) — bottom right */\n.fab-add-sector {\n  position: absolute;\n  bottom: 24px;\n  right: 24px;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, rgba(74, 222, 128, 0.3) 0%, rgba(34, 197, 94, 0.25) 100%);\n  color: #4ade80;\n  border: 1px solid rgba(74, 222, 128, 0.4);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n.fab-add-sector:hover {\n  background: linear-gradient(135deg, rgba(74, 222, 128, 0.45) 0%, rgba(34, 197, 94, 0.35) 100%);\n  border-color: rgba(74, 222, 128, 0.6);\n  color: #86efac;\n  box-shadow: 0 6px 20px rgba(74, 222, 128, 0.25);\n  transform: scale(1.08);\n}\n\n.fab-add-sector:active {\n  transform: scale(0.95);\n}\n\n.fab-tooltip {\n  position: absolute;\n  right: 56px;\n  white-space: nowrap;\n  background: rgba(30, 30, 30, 0.95);\n  color: #e2e8f0;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 5px 10px;\n  border-radius: 6px;\n  pointer-events: none;\n  opacity: 0;\n  transform: translateX(4px);\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.fab-add-sector:hover .fab-tooltip {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.header-title {\n  color: #e2e8f0;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.3px;\n  flex-shrink: 0;\n  display: none;\n}\n\n.smart-board-header p {\n  margin: 0;\n  color: #64748b;\n  font-size: 13px;\n  flex-shrink: 0;\n  display: none;\n}\n\n.connection-status {\n  font-size: 11px;\n  font-weight: 500;\n  padding: 4px 10px;\n  border-radius: 20px;\n  display: none;\n}\n\n.connection-status.connected {\n  color: #4ade80;\n  background: rgba(74, 222, 128, 0.1);\n}\n\n.connection-status.disconnected {\n  color: #f87171;\n  background: rgba(248, 113, 113, 0.1);\n}\n\n/* ===== MARKET INDICES — inline compact ===== */\n.market-indices {\n  display: flex;\n  gap: 6px;\n  flex: 1;\n  justify-content: center;\n  align-items: stretch;\n}\n\n.index-card {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 6px 14px;\n  background: #22232b;\n  border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  transition: all 0.2s ease;\n  overflow: hidden;\n  flex-shrink: 0;\n  min-width: 180px;\n}\n\n.index-card:hover {\n  border-color: rgba(255, 255, 255, 0.12);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n/* Index Card Color Variants */\n.index-card.positive {\n  border-color: rgba(74, 222, 128, 0.15);\n}\n\n.index-card.negative {\n  border-color: rgba(248, 113, 113, 0.15);\n}\n\n.index-card.neutral {\n  border-color: rgba(255, 255, 255, 0.06);\n}\n\n/* Row Top — Price + Change */\n.index-row-top {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n/* Row Bottom — Symbol + Volume */\n.index-row-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.index-symbol {\n  font-size: 11px;\n  font-weight: 600;\n  color: #ffffff;\n  letter-spacing: 0.2px;\n  text-transform: uppercase;\n}\n\n.index-volume {\n  font-family: 'JetBrains Mono', 'Fira Code', 'SF Mono', 'Consolas', monospace;\n  font-size: 11px;\n  font-weight: 600;\n  color: #ffffff;\n  letter-spacing: 0;\n}\n\n.index-change {\n  font-size: 12px;\n  font-weight: 700;\n  padding: 0;\n  border-radius: 0;\n  background: none;\n}\n\n/* Change text colors — green positive, red negative */\n.index-card.positive .index-change {\n  color: #4ade80;\n}\n\n.index-card.negative .index-change {\n  color: #f87171;\n}\n\n.index-card.neutral .index-change {\n  color: #94a3b8;\n}\n\n/* Price */\n.index-price {\n  font-family: 'JetBrains Mono', 'Fira Code', 'SF Mono', 'Consolas', monospace;\n  font-size: 17px;\n  font-weight: 700;\n  letter-spacing: -0.3px;\n  line-height: 1;\n}\n\n/* Index price colors — always white */\n.index-card.positive .index-price,\n.index-card.negative .index-price,\n.index-card.neutral .index-price {\n  color: #ffffff;\n}\n\n/* Sparkline Chart (hidden) */\n.index-sparkline {\n  display: none;\n}\n\n/* Responsive — tablet */\n@media (max-width: 768px) {\n  .smart-board-header {\n    flex-wrap: wrap;\n    gap: 4px;\n    margin-bottom: 4px;\n  }\n\n  .header-stats {\n    min-width: auto;\n    gap: 6px;\n    font-size: 10px;\n  }\n\n  .market-indices {\n    flex: 1;\n    gap: 4px;\n    overflow-x: auto;\n    justify-content: flex-start;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n  }\n\n  .market-indices::-webkit-scrollbar {\n    display: none;\n  }\n\n  .index-card {\n    padding: 4px 10px;\n    gap: 1px;\n    min-width: 150px;\n  }\n\n  .index-symbol {\n    font-size: 9px;\n  }\n\n  .index-volume {\n    font-size: 9px;\n  }\n\n  .index-change {\n    font-size: 10px;\n  }\n\n  .index-price {\n    font-size: 14px;\n  }\n}\n\n/* Responsive — mobile */\n@media (max-width: 480px) {\n  .smart-board-container {\n    padding: 0 4px;\n  }\n\n  .fixed-header {\n    margin: 0 0 2px 0;\n  }\n\n  .smart-board-header {\n    gap: 3px;\n  }\n\n  .header-stats {\n    gap: 5px;\n    font-size: 10px;\n  }\n\n  .index-card {\n    padding: 3px 8px;\n    gap: 0;\n    min-width: 130px;\n  }\n\n  .index-symbol {\n    font-size: 8px;\n  }\n\n  .index-volume {\n    font-size: 8px;\n  }\n\n  .index-change {\n    font-size: 9px;\n  }\n\n  .index-price {\n    font-size: 13px;\n  }\n\n  .index-row-top {\n    gap: 6px;\n  }\n\n  .table-header,\n  .table-row {\n    gap: 3px;\n    padding: 2px 3px;\n  }\n\n  .sector-card {\n    border-radius: 4px;\n  }\n}\n\n/* ===== SECTORS GRID ===== */\n.sectors-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 6px;\n  align-items: start;\n}\n\n@media (min-width: 1200px) {\n  .sectors-grid {\n    grid-template-columns: repeat(8, 1fr);\n  }\n}\n\n@media (min-width: 900px) and (max-width: 1199px) {\n  .sectors-grid {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n@media (max-width: 899px) {\n  .sectors-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 4px;\n  }\n}\n\n@media (max-width: 560px) {\n  .sectors-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 4px;\n  }\n\n  .table-header,\n  .table-row {\n    gap: 3px;\n    padding: 2px 4px;\n  }\n}\n\n/* ===== SECTOR CARD ===== */\n.sector-card {\n  background: #22232b;\n  border-radius: 6px;\n  overflow: hidden;\n  min-width: 0;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.sector-card:hover:not(.dragging) {\n  border-color: rgba(255, 255, 255, 0.12);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n/* ===== SECTOR HEADER ===== */\n.sector-header {\n  background: #2a2b35;\n  padding: 5px 6px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n  flex-shrink: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.sector-header h3 {\n  margin: 0;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n\n/* ===== SECTOR TABLE ===== */\n.sector-table {\n  font-size: 10px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.table-header {\n  display: flex;\n  align-items: center;\n  padding: 3px 5px;\n  background: #282930;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n  font-weight: 700;\n  color: #64748b;\n  font-size: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  flex-shrink: 0;\n}\n\n.table-header .col-symbol {\n  text-align: left;\n  color: #ffffff;\n}\n\n.table-header .col-price,\n.table-header .col-change,\n.table-header .col-volume,\n.table-header .col-min22-price,\n.table-header .col-min22,\n.table-header .col-min22-pct {\n  text-align: right;\n  color: #ffffff;\n}\n\n/* Table body */\n.table-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.table-row {\n  display: flex;\n  align-items: center;\n  padding: 4px 6px;\n  transition: background 0.15s ease;\n  background: #1e1f27;\n  position: relative;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 3px;\n}\n\n/* Zebra striping */\n.table-row:nth-child(even) {\n  background: #22232b;\n}\n\n.table-row:last-child {\n  /* gap handles spacing now */\n}\n\n.table-row:hover {\n  filter: brightness(1.15);\n}\n\n/* ===== ROW BACKGROUND COLORS ===== */\n.table-row.ceiling {\n  background: rgba(255,128,255);\n}\n\n.table-row.positive {\n  background: #00EE00;\n}\n\n.table-row.positive-muted {\n  background: #98fb98;\n}\n\n.table-row.negative {\n  background: rgba(255,62,62);\n}\n\n.table-row.negative-muted {\n  background: rgba(255,193,193);\n}\n\n.table-row.neutral {\n  background: rgba(255,255,128);\n}\n\n.table-row.floor {\n  background: rgba(0,255,255);\n}\n\n/* ===== CATCH-ALL: Dark text on ALL colored row backgrounds ===== */\n.table-row.ceiling span,\n.table-row.positive span,\n.table-row.positive-muted span,\n.table-row.negative span,\n.table-row.negative-muted span,\n.table-row.neutral span,\n.table-row.floor span {\n  color: #0f172a !important;\n}\n\n/* ===== COLUMNS ===== */\n.col-symbol,\n.col-price,\n.col-change,\n.col-volume {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  box-sizing: border-box;\n}\n\n.col-symbol {\n  flex: 0 1 20%;\n  font-weight: 600;\n  color: #e2e8f0;\n  font-size: 12px;\n  text-align: left;\n}\n\n.col-price {\n  flex: 0 1 20%;\n  text-align: right;\n  font-weight: 600;\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n  color: #e2e8f0;\n}\n\n/* ===== PRICE COLORS — Dark text on colored background ===== */\n.table-row.ceiling .col-price,\n.table-row.positive .col-price,\n.table-row.positive-muted .col-price,\n.table-row.negative .col-price,\n.table-row.negative-muted .col-price,\n.table-row.neutral .col-price,\n.table-row.floor .col-price {\n  color: #0f172a;\n}\n\n/* ===== CHANGE % BADGE ===== */\n.col-change {\n  flex: 0 1 40%;\n  text-align: right;\n  font-weight: 600;\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n  padding: 1px 4px;\n  border-radius: 3px;\n  color: #e2e8f0;\n}\n\n/* Change badge colors — Dark text on colored background */\n.col-change.ceiling,\n.col-change.positive,\n.col-change.positive-muted,\n.col-change.negative,\n.col-change.negative-muted,\n.col-change.neutral,\n.col-change.floor {\n  color: #0f172a;\n}\n\n/* Volume */\n.col-volume {\n  flex: 0 1 20%;\n  text-align: right;\n  color: #94a3b8;\n  font-size: 12px;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  padding: 0;\n}\n\n/* Volume colors — Dark text on colored background */\n.col-volume.ceiling,\n.col-volume.positive,\n.col-volume.positive-muted,\n.col-volume.negative,\n.col-volume.negative-muted,\n.col-volume.neutral,\n.col-volume.floor {\n  color: #0f172a;\n}\n\n/* Symbol color — Dark text on colored background */\n.table-row.ceiling .col-symbol,\n.table-row.positive .col-symbol,\n.table-row.positive-muted .col-symbol,\n.table-row.negative .col-symbol,\n.table-row.negative-muted .col-symbol,\n.table-row.neutral .col-symbol,\n.table-row.floor .col-symbol {\n  color: #0f172a;\n}\n\n/* ===== MIN 22 COLUMNS ===== */\n.col-min22-price {\n  flex: 1 1 0;\n  color: #e2e8f0;\n}\n\n.table-row.positive .col-min22-price,\n.table-row.negative .col-min22-price,\n.table-row.neutral .col-min22-price,\n.table-row.positive-muted .col-min22-price,\n.table-row.negative-muted .col-min22-price,\n.table-row.ceiling .col-min22-price,\n.table-row.floor .col-min22-price {\n  color: #0f172a;\n}\n\n.col-min22-price,\n.col-min22,\n.col-min22-pct {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  box-sizing: border-box;\n  font-size: 12px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  text-align: right;\n}\n\n.col-min22 {\n  flex: 1 1 0;\n  color: #e2e8f0;\n}\n\n.col-min22-pct {\n  flex: 1 1 0;\n  padding: 1px 4px;\n  border-radius: 3px;\n}\n\n/* Min22 text colors on colored backgrounds */\n.table-row.positive .col-min22,\n.table-row.negative .col-min22,\n.table-row.neutral .col-min22,\n.table-row.positive-muted .col-min22,\n.table-row.negative-muted .col-min22,\n.table-row.ceiling .col-min22,\n.table-row.floor .col-min22 {\n  color: #0f172a;\n}\n\n.col-min22-pct.positive,\n.col-min22-pct.negative,\n.col-min22-pct.neutral,\n.col-min22-pct.positive-muted,\n.col-min22-pct.negative-muted,\n.col-min22-pct.ceiling,\n.col-min22-pct.floor {\n  color: #0f172a;\n}\n\n.table-header .col-min22-price,\n.table-header .col-min22,\n.table-header .col-min22-pct {\n  color: #e2e8f0;\n  font-weight: 600;\n  font-size: 12px;\n  text-transform: uppercase;\n}\n\n/* ===== LOADING OVERLAY ===== */\n.loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(26, 27, 35, 0.85);\n  z-index: 9999;\n  backdrop-filter: blur(4px);\n}\n\nbody.loading-active {\n  overflow: hidden;\n}\n\n/* ===== TOAST NOTIFICATION ===== */\n.toast-container {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.toast {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n  animation: toast-slide-in 0.3s ease;\n  max-width: 320px;\n}\n\n.toast.error {\n  background: #2a2b35;\n  color: #f87171;\n  border: 1px solid rgba(248, 113, 113, 0.2);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n}\n\n.toast.success {\n  background: #1a2e1a;\n  color: #4ade80;\n  border: 1px solid rgba(74, 222, 128, 0.25);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\n}\n\n.toast .toast-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.toast.success .toast-icon {\n  color: #4ade80;\n}\n\n.toast.error .toast-icon {\n  color: #f87171;\n}\n\n.toast .toast-message {\n  flex: 1;\n}\n\n.toast .toast-action {\n  padding: 4px 10px;\n  background: rgba(251, 113, 133, 0.12);\n  color: #fb7185;\n  border: 1px solid rgba(251, 113, 133, 0.2);\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 10px;\n  font-weight: 500;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.toast .toast-action:hover {\n  background: rgba(251, 113, 133, 0.2);\n}\n\n.toast .toast-close {\n  background: none;\n  border: none;\n  color: #64748b;\n  cursor: pointer;\n  padding: 2px;\n  font-size: 14px;\n  line-height: 1;\n  transition: color 0.2s ease;\n}\n\n.toast .toast-close:hover {\n  color: #94a3b8;\n}\n\n@keyframes toast-slide-in {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* (responsive adjustments moved to main responsive block above) */\n\n/* ===== DRAG AND DROP STYLES ===== */\n\n/* Ghost card — the dragged item shown at its preview drop position */\n.sector-card.drag-ghost {\n  opacity: 0.25;\n  border: 2px dashed rgba(59, 130, 246, 0.6) !important;\n  background: rgba(59, 130, 246, 0.06) !important;\n  pointer-events: none;\n  box-shadow: none !important;\n}\n\n.sector-card.drag-ghost * {\n  opacity: 0.3;\n}\n\n/* Active drag state on the grid */\n.sectors-grid.dragging-active {\n  background: rgba(40, 115, 255, 0.02);\n  border-radius: 8px;\n}\n\n/* Make cards accept drops */\n.sector-card[draggable=\"true\"] {\n  cursor: grab;\n}\n\n.sector-card[draggable=\"true\"]:active {\n  cursor: grabbing;\n}\n\n.drag-handle {\n  position: absolute;\n  left: 6px;\n  color: rgba(255, 255, 255, 0.3);\n  font-size: 10px;\n  cursor: grab;\n  user-select: none;\n  letter-spacing: -2px;\n  transition: color 0.2s ease;\n}\n\n.drag-handle:hover {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* ===== SECTOR HEADER ADD BUTTON (LEFT) ===== */\n.sector-add-btn {\n  position: absolute;\n  left: 18px;\n  background: rgba(74, 222, 128, 0.15);\n  color: rgba(74, 222, 128, 0.8);\n  border: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.sector-add-btn:hover {\n  background: rgba(74, 222, 128, 0.35);\n  color: #4ade80;\n}\n\n/* ===== SECTOR HEADER DELETE BUTTON (RIGHT) ===== */\n.sector-delete-btn {\n  position: absolute;\n  right: 4px;\n  background: rgba(248, 113, 113, 0.1);\n  color: rgba(248, 113, 113, 0.6);\n  border: none;\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.sector-delete-btn:hover {\n  background: rgba(248, 113, 113, 0.3);\n  color: #f87171;\n}\n\n/* ===== ROW REMOVE BUTTON ===== */\n.row-remove-btn {\n  position: absolute;\n  right: 2px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  color: #64748b;\n  border: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 3px;\n  cursor: pointer;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  padding: 2px;\n}\n\n.table-row:hover .row-remove-btn {\n  display: flex;\n  color: #BD1342;\n}\n\n.row-remove-btn:hover {\n  background: #ffffff;\n  color: #ffffff;\n}\n\n/* ===== MODAL ===== */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10001;\n  backdrop-filter: blur(4px);\n}\n\n.modal-content {\n  background: #22232b;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);\n  animation: modal-appear 0.2s ease;\n}\n\n@keyframes modal-appear {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  color: #64748b;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n  transition: color 0.2s ease;\n}\n\n.modal-close:hover {\n  color: #94a3b8;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.modal-body input {\n  width: 100%;\n  padding: 12px 16px;\n  background: #1a1b23;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: #e2e8f0;\n  font-size: 14px;\n  font-family: inherit;\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.modal-body input:focus {\n  border-color: rgba(40, 115, 255, 0.5);\n}\n\n.modal-body input::placeholder {\n  color: #64748b;\n}\n\n.modal-body p {\n  margin: 0;\n  color: #94a3b8;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.modal-error {\n  color: #fb7185;\n  font-size: 13px;\n  margin-top: 12px;\n}\n\n.modal-warning {\n  color: #fbbf24;\n  font-size: 12px;\n  margin-top: 8px;\n  font-style: italic;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.modal-btn {\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.modal-btn.cancel {\n  background: rgba(255, 255, 255, 0.06);\n  color: #94a3b8;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.modal-btn.cancel:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.modal-btn.confirm {\n  background: #2873ff;\n  color: #ffffff;\n  border: 1px solid #2873ff;\n}\n\n.modal-btn.confirm:hover:not(:disabled) {\n  background: #2060e0;\n}\n\n.modal-btn.danger {\n  background: #ef4444;\n  color: #ffffff;\n  border: 1px solid #ef4444;\n}\n\n.modal-btn.danger:hover:not(:disabled) {\n  background: #dc2626;\n}\n\n.modal-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ===== Early Signals Floating Button & Panel ===== */\n.signals-fab {\n  position: fixed;\n  bottom: 100px;\n  right: 24px;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #3b82f6;\n  color: white;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);\n  z-index: 100;\n  transition: transform 0.2s, background 0.2s, box-shadow 0.2s;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.signals-fab:hover {\n  transform: scale(1.1);\n  background: #2563eb;\n  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.5);\n}\n\n.signals-fab.active {\n  background: #1d4ed8;\n  transform: scale(1);\n}\n\n/* Overlay */\n.signals-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 199;\n}\n\n/* Right sidebar panel */\n.signals-panel {\n  position: fixed;\n  top: 0;\n  right: -900px;\n  width: 900px;\n  height: 100vh;\n  background: #141520;\n  border-left: 1px solid rgba(255, 255, 255, 0.08);\n  z-index: 200;\n  display: flex;\n  flex-direction: column;\n  transition: right 0.3s ease;\n  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.4);\n}\n\n.signals-panel.open {\n  right: 0;\n}\n\n.signals-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  flex-shrink: 0;\n}\n\n.signals-panel-header h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #e2e8f0;\n}\n\n.signals-panel-close {\n  background: none;\n  border: none;\n  color: #94a3b8;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  transition: color 0.15s, background 0.15s;\n}\n\n.signals-panel-close:hover {\n  color: #e2e8f0;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.signals-panel-body {\n  flex: 1;\n  overflow: hidden;\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n  .signals-panel {\n    width: 100vw;\n    right: -100vw;\n  }\n\n  .signals-fab {\n    bottom: 16px;\n    right: 16px;\n    width: 44px;\n    height: 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
